import {Record} from 'immutable';
import {schema} from 'normalizr';

const AIReply = Record({
    id: null,
    promptMessage: null,
    replyMessage: null,
    reply: null,
    signature: null,
});

export const AIReplySchema = new schema.Entity('aiReplies');

export default AIReply;
